import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function OgrenciPerformansTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['ogrenci-performans-testleri']} />;
}
